export default __webpack_public_path__ + "static/media/P470_P620_23M001A_GENERIC_MED_.f352449d.STEP";